import { SampleTable } from "@/shared/components/ui";
import { useFetchProspecto } from "@/shared/actions/erp";
import { useCheckPermissions } from "@/shared/hooks";
import { Button, Grid } from "@mui/material";
import { IDataProspecto } from "@/shared/interfaces/erp/prospecto";
import { useTableColumnsProspecto } from "@/shared/hooks/useTableColumnsProspecto";
import { PermissionsEnum } from "@/auth/interfaces";
import { EstadoProspectoEnum } from "@/shared";
import { OpenInNew } from "@mui/icons-material";
import { useState } from "react";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";

type InfoProspectoProps = {
  codigo: string
}
export default function InfoProspecto({ codigo }: InfoProspectoProps) {
  useCheckPermissions(PermissionsEnum.api_view_prospecto);

  const { columnsBase } = useTableColumnsProspecto({ estado_prospecto: EstadoProspectoEnum.FINALIZADO });

  const [open, setOpen] = useState(false);
  const [enabled, setEnabled] = useState(false);

  const { isLoading, data: prospectoRes,
  } = useFetchProspecto({
    page: 1,
    page_size: 1,
    codigo,
  }, enabled);


  return (
    <>
      <Button
        color="primary"
        startIcon={<OpenInNew />}
        onClick={() => {
          setOpen(true)
          setEnabled(true)
        }}
      >
        VER
      </Button>

      {
        open && (
          <ScrollableDialogProps
            onCloseIcon={() => setOpen(false)}
            open={open}
            title="Prospecto"
            minWidth="75%"
            contentNode={
              <Grid container spacing={2}>

                <Grid item xs={12}>
                  <SampleTable<IDataProspecto>
                    isLoading={isLoading}
                    data={prospectoRes?.data.data || []}
                    columns={columnsBase}
                    enablePagination
                  />
                </Grid>
              </Grid>
            }
          />
        )
      }
    </>
  );



}